"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.SiteSearch = void 0;
var _siteSearch = _interopRequireDefault(require("./components/site-search"));
exports.SiteSearch = _siteSearch["default"];